import React from 'react';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

import { HeaderProps } from './types';

export const Header: React.FC<HeaderProps> = ({ headerGroups, headerClassName }) => {
    return (
        <thead>
            {headerGroups.map((headerGroup, index) => (
                <tr key={`${index}_${headerGroup.id}`} className={classNames(headerClassName)}>
                    {headerGroup.headers.map(
                        (header, index) =>
                            header.column.getIsVisible() && (
                                <th
                                    key={`${index}_${header.id}`}
                                    colSpan={header.colSpan}
                                    className={classNames(
                                        {
                                            asc: ' sort-ascending table-sort-asc',
                                            desc: ' sort-descending table-sort-desc',
                                        }[header.column.getIsSorted() as string] ?? '',
                                    )}
                                >
                                    {header.isPlaceholder ? null : (
                                        <div
                                            {...{
                                                className: header.column.getCanSort() ? 'cursor-pointer select-none d-inline' : '',
                                                onClick: header.column.getToggleSortingHandler(),
                                            }}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {header.column.getIsSorted() && <i />}
                                        </div>
                                    )}
                                </th>
                            ),
                    )}
                </tr>
            ))}
        </thead>
    );
};

export default Header;
